import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=673d0462&scoped=true"
import script from "../js/Auth/index.js?vue&type=script&lang=js&external"
export * from "../js/Auth/index.js?vue&type=script&lang=js&external"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=673d0462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d0462",
  null
  
)

export default component.exports